// removed by extract-text-webpack-plugin
module.exports = {"h1":"H1__h1","alternate":"H1__alternate"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/typography/H1/H1.css
// module id = 548
// module chunks = 8